const NOXWELL_GA4_DEBUG = true;

(function () {
  const leadFormLastSent = new WeakMap();
  const leadFormCooldownMs = 5000;

  function logEvent(eventName, params) {
    if (NOXWELL_GA4_DEBUG) {
      console.log('[Noxwell GA4 Lead Tracking]', eventName, params);
    }
  }

  function sendGa4Event(eventName, params) {
    if (typeof window.gtag !== 'function') {
      console.warn('[Noxwell GA4 Lead Tracking] window.gtag is not available.', eventName, params);
      return;
    }

    window.gtag('event', eventName, params);
    logEvent(eventName, params);
  }

  function normalize(value) {
    return (value || '').toString().toLowerCase();
  }

  function getPageContext() {
    return normalize([window.location.pathname, window.location.search, document.title].join(' '));
  }

  function getFormContext(form) {
    return normalize([
      form.getAttribute('action'),
      form.getAttribute('id'),
      form.getAttribute('name'),
      form.getAttribute('class')
    ].join(' '));
  }

  function formHasLeadFields(form) {
    const emailField = form.querySelector('input[type="email"], input[name*="email" i]');
    const phoneField = form.querySelector('input[type="tel"], input[name*="phone" i], input[name*="tel" i]');
    const messageField = form.querySelector('textarea, input[name*="message" i], textarea[name*="message" i], input[name*="body" i], textarea[name*="body" i]');

    return Boolean(emailField || phoneField || messageField);
  }

  function isLeadForm(form) {
    const formContext = getFormContext(form);

    return (
      formContext.includes('/contact') ||
      formContext.includes('contact') ||
      formContext.includes('trade') ||
      formContext.includes('quote') ||
      formContext.includes('wholesale') ||
      formContext.includes('bulk') ||
      formHasLeadFields(form)
    );
  }

  function detectFormType(form) {
    const context = [getPageContext(), getFormContext(form)].join(' ');

    if (
      context.includes('trade') ||
      context.includes('wholesale') ||
      context.includes('bulk') ||
      context.includes('quote')
    ) {
      return 'trade_price';
    }

    if (context.includes('contact')) {
      return 'contact';
    }

    return 'lead_form';
  }

  function handleFormSubmit(event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !isLeadForm(form)) {
      return;
    }

    const now = Date.now();
    const lastSentAt = leadFormLastSent.get(form) || 0;

    if (now - lastSentAt < leadFormCooldownMs) {
      if (NOXWELL_GA4_DEBUG) {
        console.log('[Noxwell GA4 Lead Tracking] Duplicate generate_lead skipped.', form);
      }
      return;
    }

    leadFormLastSent.set(form, now);

    sendGa4Event('generate_lead', {
      form_type: detectFormType(form),
      page_location: window.location.href,
      page_title: document.title
    });
  }

  function linkMatchesShowroom(anchor, hrefValue, linkText) {
    const linkContext = normalize([hrefValue, linkText].join(' '));

    return (
      linkContext.includes('showroom') ||
      linkContext.includes('google maps') ||
      linkContext.includes('maps') ||
      linkContext.includes('direction') ||
      linkContext.includes('get directions')
    );
  }

  function handleLinkClick(event) {
    const anchor = event.target.closest('a');

    if (!anchor) {
      return;
    }

    const hrefValue = anchor.getAttribute('href') || '';
    const linkText = (anchor.textContent || '').trim();
    const hrefLower = normalize(hrefValue);

    if (hrefLower.startsWith('tel:')) {
      sendGa4Event('phone_click', {
        phone_number: hrefValue,
        page_location: window.location.href,
        page_title: document.title
      });
    }

    if (hrefLower.startsWith('mailto:')) {
      sendGa4Event('email_click', {
        email_address: hrefValue,
        page_location: window.location.href,
        page_title: document.title
      });
    }

    if (linkMatchesShowroom(anchor, hrefValue, linkText)) {
      sendGa4Event('showroom_click', {
        link_url: hrefValue,
        link_text: linkText,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }

  document.addEventListener('submit', handleFormSubmit, true);
  document.addEventListener('click', handleLinkClick, true);
})();

(function () {
  const projects = {
    '/blogs/kitchen-projects/rhodes-apartment-double-bowl-to-single-bowl-sink-upgrade': {
      image: 'https://cdn.shopify.com/s/files/1/0787/9619/4020/articles/noxwell-project-rhodes-apartment-sink-upgrade.png?v=1783774798',
      imageAlt: 'Rhodes apartment kitchen upgraded from a double bowl sink to a Noxwell single bowl sink',
      heading: 'Product Used',
      links: [
        {
          label: 'Noxwell KSSV-7145 brushed stainless steel single bowl kitchen sink',
          href: 'https://www.noxwell.com.au/products/noxwell-brushed-silver-kitchen-sink-single-bowl-710mmx450mm-kssv-7145'
        }
      ]
    },
    '/blogs/granny-flat-projects/merrylands-granny-flat-bathroom-package': {
      image: 'https://cdn.shopify.com/s/files/1/0787/9619/4020/articles/noxwell-project-merrylands-granny-flat-bathroom.png?v=1783817654',
      imageAlt: 'Merrylands granny flat bathroom using Noxwell vanity toilet and stainless steel accessories',
      heading: 'Products Used',
      links: [
        {
          label: 'Noxwell white 2-door bathroom vanity floor standing 605mm',
          href: 'https://www.noxwell.com.au/products/noxwell-white-2-door-bathroom-vanity-floor-standing-605mm'
        },
        {
          label: 'BASV-3008 brushed stainless steel towel rail 600mm',
          href: 'https://www.noxwell.com.au/products/brushed-stainless-steel-towel-rail-600mm-wall-mounted-noxwell-basv-3008'
        },
        {
          label: 'BASV-3010 stainless steel towel rack with rail 600mm',
          href: 'https://www.noxwell.com.au/products/stainless-steel-towel-rack-with-rail-600mm-wall-mounted-noxwell-basv-3010'
        },
        {
          label: 'BTWH-3092 gloss white vortex rimless toilet',
          href: 'https://www.noxwell.com.au/products/noxwell-gloss-white-vortex-toilet-rimless-btwh-3092'
        }
      ]
    }
  };

  function ensureProjectRestoreStyles() {
    if (document.getElementById('noxwell-project-restore-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'noxwell-project-restore-styles';
    style.textContent = `
      .noxwell-project-restore--image {
        max-width: 720px;
        margin: 0 auto 28px;
      }
      .noxwell-project-restore--image img {
        display: block;
        width: 100%;
        height: auto;
        border-radius: 8px;
      }
      .noxwell-project-restore--products {
        margin-top: 28px;
      }
      .noxwell-project-restore--products ul {
        padding-left: 1.2em;
      }
    `;
    document.head.appendChild(style);
  }

  function restoreProjectArticleContent() {
    const project = projects[window.location.pathname];

    if (!project) {
      return;
    }

    const content = document.querySelector('.article__content');

    if (!content || content.querySelector('.noxwell-project-restore')) {
      return;
    }

    ensureProjectRestoreStyles();

    if (!content.querySelector(`a[href="${project.links[0].href}"]`)) {
      const products = document.createElement('section');
      products.className = 'noxwell-project-restore noxwell-project-restore--products';
      products.innerHTML = `
        <h2>${project.heading}</h2>
        <ul>
          ${project.links.map((link) => `<li><a href="${link.href}">${link.label}</a></li>`).join('')}
        </ul>
      `;
      content.appendChild(products);
    }

    if (!content.querySelector(`img[src*="${project.image.split('/').pop().split('?')[0]}"]`)) {
      const figure = document.createElement('figure');
      figure.className = 'noxwell-project-restore noxwell-project-restore--image';
      figure.innerHTML = `<img src="${project.image}" alt="${project.imageAlt}" loading="lazy">`;
      content.insertBefore(figure, content.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreProjectArticleContent);
  } else {
    restoreProjectArticleContent();
  }
})();
